import { format } from 'date-fns'

export const convertToDateTimeString = (date: number | Date) => {
	if (!date) {
		return ' -- '
	}

	return format(date, 'E, MMM d, yyyy, h:mm a')
}
export const convertToDateString = (date: number | Date) => {
	if (!date) {
		return ' -- '
	}

	return format(date, 'E, MMM d, yyyy')
}
export const convertToDateTimeShort = (date: number | Date | undefined) => {
	if (!date) {
		return ' -- '
	}

	return format(date, 'M/d/yyyy, h:mm a')
}
export const convertToDateShort = (date: number | Date | undefined) => {
	if (!date) {
		return ' -- '
	}

	return format(date, 'MM/dd/yyyy')
}
export const convertToTime = (date: number | Date) => {
	if (!date) {
		return ' -- '
	}

	return format(date, 'H:mm')
}

export const formatPhoneNumber = (phonenumber: string) => {
	let formatedNumber = phonenumber
	formatedNumber = formatedNumber.replace(/\D/g, '')
	if (formatedNumber.length === 10) {
		formatedNumber = '+1' + formatedNumber
	}
	if (formatedNumber.length === 11) {
		formatedNumber = '+' + formatedNumber
	}
	return formatedNumber
}

export const flattenObject = (ob: { [key: string]: any }) => {
	let toReturn: { [key: string]: any } = {}

	for (const i in ob) {
		if (!ob.hasOwnProperty(i)) continue

		if (typeof ob[i] === 'object') {
			let flatObject = flattenObject(ob[i])
			for (const x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue

				toReturn[i + '.' + x] = flatObject[x]
			}
		} else {
			toReturn[i] = ob[i]
		}
	}
	return toReturn
}

export const objectOfBoolsToArray = (object: { [key: string]: any }) => {
	const arrayToReturn = []
	for (const key in object) {
		if (object[key]) {
			arrayToReturn.push(key)
		}
	}
	return arrayToReturn
}

export const replaceAll = (target: string, search: string, replacement: string) => {
	return target.replace(new RegExp(search, 'g'), replacement)
}
